export default [
  {
    header: "COMEX",
    resource: "Shipping Program",
    action: "menu",
  },
  {
    title: "Comex Hold Co",
    route: "comexholdco",
    icon: "UserPlusIcon",
    action: "menu",
    resource: "Comex Hold Co",
  },
  {
    title: 'Precios Comercial',
    route: "comercialprecios",
    icon: 'DollarSignIcon',
    action: "menu",
    resource: "Precios Comercial",
  },

  // {
  //   title: 'Precios Comercial',
  //   icon: 'DollarSignIcon',
  //   children: [
  //         {
  //             title: 'Blueberries',
  //             route: 'comercialprecios',
  //             action: 'menu',
  //             resource: 'Shipping Advice'
  //         },
  //         {
  //             title: 'Grapes',
  //             route: 'agvpacking',
  //             action: 'menu',
  //             resource: 'Shipping Advice'
  //         },
  //         {
  //           title: 'Asparagus',
  //           route: 'agvpacking',
  //           action: 'menu',
  //           resource: 'Shipping Advice'
  //       },

  //     ],
  // },
  {
    title: "Shipping Program",
    route: "shippingprogram",
    icon: "TruckIcon",
    action: "menu",
    resource: "Shipping Program",
  },
  {
    title: "Shipping Advice",
    route: "shippingadvice",
    icon: "BriefcaseIcon",
    action: "menu",
    resource: "Shipping Advice",
  },
  {
    title: "Mail Report",
    route: "correosenviados",
    icon: "FileTextIcon",
    action: "menu",
    resource: "Shipping Advice",
  },
  {
    title: "Envio Automatico",
    route: "envioautomatico",
    icon: "ExternalLinkIcon",
    action: "menu",
    resource: "Shipping Advice",
  },
];
